// extracted by mini-css-extract-plugin
export default {"tab":"ecWO7G0fLC","content":"gyOXN6oWwi","content_widthConstrainted":"t5yckEWqsj"};